import React from 'react';

const SvgAg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="AG_svg__c" d="M0 0h28L14 20z" />
      <path
        id="AG_svg__f"
        d="M14 11l-2.296 2.543.175-3.422-3.422.175L11 8 8 5.333 11.879 6l-.546-4L14 5.333 16.667 2l-.546 4L20 5.333 17 8l2.543 2.296-3.422-.175.175 3.422z"
      />
      <filter
        x="-31.5%"
        y="-34.2%"
        width="163%"
        height="162.4%"
        filterUnits="objectBoundingBox"
        id="AG_svg__e"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path id="AG_svg__h" d="M0 8h28v5.333H0z" />
      <filter
        x="-5.4%"
        y="-28.1%"
        width="110.7%"
        height="156.2%"
        filterUnits="objectBoundingBox"
        id="AG_svg__g"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AG_svg__b" fill="#fff">
        <use xlinkHref="#AG_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#AG_svg__a" />
      <path fill="#E2243B" mask="url(#AG_svg__b)" d="M0 0h28v20H0z" />
      <g mask="url(#AG_svg__b)">
        <mask id="AG_svg__d" fill="#fff">
          <use xlinkHref="#AG_svg__c" />
        </mask>
        <use fill="#262626" xlinkHref="#AG_svg__c" />
        <g mask="url(#AG_svg__d)">
          <use fill="#000" filter="url(#AG_svg__e)" xlinkHref="#AG_svg__f" />
          <use fill="#FFCF3C" xlinkHref="#AG_svg__f" />
        </g>
        <g mask="url(#AG_svg__d)">
          <use fill="#000" filter="url(#AG_svg__g)" xlinkHref="#AG_svg__h" />
          <use fill="#1984D8" xlinkHref="#AG_svg__h" />
        </g>
        <path fill="#FFF" mask="url(#AG_svg__d)" d="M0 13.333h28V20H0z" />
      </g>
    </g>
  </svg>
);

export default SvgAg;
